import { QueryClient } from '@tanstack/react-query';

/**
 * Один кеш на приложение. Его чистит выход (`userStore.logout`) и вход/выход «как пользователь»:
 * на одном адресе живут все компании, и данные прошлой сессии не должны мелькнуть следующей.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      gcTime: 10 * 60 * 1000,
      // 4xx повторять бессмысленно: ответ не изменится, а «нет доступа» (403)
      // интерфейс узнавал бы на секунду позже и успевал показать запрещённое.
      retry: (failureCount, error) => {
        const e = error as { status?: number; response?: { status?: number } };
        const status = e?.status ?? e?.response?.status;
        if (status && status >= 400 && status < 500) return false;
        return failureCount < 1;
      },
      refetchOnWindowFocus: true,
      refetchOnMount: true,
    },
  },
});
